import React, { Component } from "react";
import { connect } from "react-redux";
import { string, number as numberType, bool, func } from "prop-types";
import { actions as accountsActions } from "reducers/accounts";
import * as i18nUtils from "util/i18n";

import ListItem from "pages/_components/listItem/ListItem";

class AccountsListItem extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        accountNumber: string.isRequired,
        label: string,
        productId: string,
        productType: string.isRequired,
        amountLabel: string.isRequired,
        availableBalance: numberType.isRequired,
        hideAmountLabel: bool,
        showLink: bool,
    };

    static defaultProps = {
        label: null,
        productId: null,
        hideAmountLabel: false,
        showLink: true,
    };

    productType = () => {
        const { productType } = this.props;

        if (productType === "CA") {
            return i18nUtils.get("accounts.productType.savings");
        }
        if (productType === "CC") {
            return i18nUtils.get("accounts.productType.checking");
        }
        if (productType === "CE") {
            return i18nUtils.get("accounts.productType.specialChecking");
        }

        return "";
    };

    render() {
        const {
            label,
            accountNumber,
            availableBalance,
            amountLabel = i18nUtils.get("accounts.availableBalance"),
            productId,
            hideAmountLabel,
            showLink,
            ...props
        } = this.props;
        let productName = "";
        if (label === "alias not set") {
            productName = "Nombre editable";
        } else {
            productName = label;
        }
        const reference = `${i18nUtils.get("global.number")} ${accountNumber}`;
        const productTypeTitle = i18nUtils.get("desktop.widgets.account");

        return (
            <ListItem
                {...props}
                idProduct={productId}
                productTypeTitle={productTypeTitle}
                title={this.productType()}
                name={productName}
                reference={reference}
                amount={availableBalance}
                amountLabel={!hideAmountLabel && amountLabel}
                path={() => {
                    const { dispatch } = this.props;
                    dispatch(accountsActions.filterBalances(this.props));
                    return showLink ? `/accounts/${productId}` : null;
                }}
            />
        );
    }
}

export default connect()(AccountsListItem);
